var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrow = function SvgArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22.5 19.98",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.67 19.73c.18.16.42.25.66.24s.48-.11.64-.29c.17-.18.26-.41.26-.66 0-.24-.1-.48-.27-.65l-7.81-7.45 18.42.03c.25 0 .49-.1.66-.27a.94.94 0 0 0 0-1.32.92.92 0 0 0-.66-.28L3.14 9.05l7.81-7.43c.09-.08.16-.19.21-.3s.08-.23.08-.36c0-.12-.02-.25-.06-.36a.9.9 0 0 0-.2-.31.9.9 0 0 0-.3-.21c-.1-.05-.22-.08-.34-.08s-.25.02-.36.06-.22.11-.31.2L.39 9.08a1.25 1.25 0 0 0-.37 1.08c.04.28.17.53.37.72z"
  })));
};
export default SvgArrow;